(() => {
  if (customElements.get('dbs-google-rating')) return;

  let request;

  const showReviewAnchor = () => {
    if (window.location.hash !== '#carthike-review-grid') return;
    const reviews = document.getElementById('carthike-review-grid');
    if (!reviews) return;
    const heading = reviews.closest('.shopify-section')?.previousElementSibling?.querySelector('h2');
    (heading || reviews).scrollIntoView({ block: 'start' });
  };

  window.addEventListener('hashchange', showReviewAnchor);

  const getReviews = (shop) => {
    if (request) return request;

    const url = new URL('https://googlereviews.carthike.com/api/widget/public/config');
    url.searchParams.set('shop', shop);
    url.searchParams.set('widgetType', 'grid');

    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 8000);

    request = fetch(url, {
      credentials: 'omit',
      referrerPolicy: 'no-referrer',
      cache: 'no-store',
      signal: controller.signal,
    })
      .then((response) => {
        if (!response.ok) throw new Error('Review source unavailable');
        return response.json();
      })
      .then((data) => {
        const rating = Number(data?.reviewMeta?.averageRating);
        const count = Number(data?.reviewMeta?.totalReviewCount);

        if (!Number.isFinite(rating) || rating <= 0 || rating > 5 || !Number.isSafeInteger(count) || count <= 0) {
          throw new Error('Review summary unavailable');
        }

        return { rating, count };
      })
      .finally(() => clearTimeout(timeout));

    return request;
  };

  class DbsGoogleRating extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';

      if (document.readyState === 'complete') {
        showReviewAnchor();
        this.updateRating();
      } else {
        window.addEventListener('load', () => {
          showReviewAnchor();
          this.updateRating();
        }, { once: true });
      }
    }

    async updateRating() {
      try {
        const { rating, count } = await getReviews(this.dataset.shop);
        if (!this.isConnected) return;

        const locale = this.dataset.locale || 'de';
        const ratingText = new Intl.NumberFormat(locale, {
          minimumFractionDigits: 1,
          maximumFractionDigits: 1,
        }).format(rating);
        const countText = new Intl.NumberFormat(locale).format(count);
        const formatLabel = (template) => template.replaceAll('__rating__', ratingText).replaceAll('__count__', countText);

        this.querySelectorAll('[data-dbs-review-text]').forEach((element) => {
          const template = element.dataset.dbsReviewText === 'short' ? this.dataset.shortLabel : this.dataset.fullLabel;
          element.textContent = formatLabel(template);
          element.hidden = false;
        });

        this.style.setProperty('--dbs-review-fill', `${(rating / 5) * 100}%`);
        this.querySelector('[data-dbs-review-stars]').hidden = false;
        this.querySelector('[data-dbs-review-fallback]').hidden = true;
        this.closest('a')?.setAttribute('aria-label', formatLabel(this.dataset.accessibleLabel));
        this.dataset.status = 'ready';
      } catch {
        this.dataset.status = 'unavailable';
      }
    }
  }

  customElements.define('dbs-google-rating', DbsGoogleRating);
})();
